import { connect } from 'react-redux';
import {
  sendMessage,
  saveNewMessageEditorState,
  clearPendingCaretInsert,
  setBtnActivity,
  onPasteText,
  loadPartnerTagsForSelectedTicketOfTab,
  setChatMacroRecommendationsEnabled,
  addNoteToSpecificTicket,
} from '../actions';
import { setConversationBlockedWordsFound, setConversationOverridableWordsFound } from 'actions/conversationActions';
import { handleUseChatMacroRecommendation } from '../actions/tools/TaggingActions';
import { loadBusinessAlertsForAccount } from '../actions/searchActions';
import { scrollRequirementMet } from '../actions/scrollActions';
import NewMessage from '../components/Messages/NewMessage/NewMessage';
import {
  getMultiIntentClassification,
  extractSelectedTicketBusinessDetailsFieldValueFromState,
  getLastSuccessfulMessageFromSimplr,
  extractSelectedTicketIdFromState,
  extractSelectedTicketBusinessDetailsFromState,
  isSelectedConversationLoaded,
  checkSmbSpelling,
  getNewMessagesEditor,
  getNewMessagesCouponCodeType,
  hasExpertReplied,
  checkPrePopulatedResponseConfig,
  extractSelectedTicketFromState,
  hasMessageBeenRead,
  getBusinessBlacklistWordsInfoOfSelectedTicket,
  getBusinessBlacklistRegexesInfoOfSelectedTicket,
  isSmbTaggingRequiredForSelectedTicket,
  extractSelectedInboxTab,
  getSelectedUnSentMessage,
  chatMacroRecommendationsAvailable,
  shouldDisplayChatMacroRecommendations,
  getClipboardTextForSpecificTicketId,
  extractDebounceAmountForGetPredictionTextFromState,
  isCommerceWizardActive,
  getAllMessages,
  selectIsTicketTranslated,
} from '../extractFromState';
import { handleEscalationPopup } from '../actions/popupActions';
import { extractSimplrTags } from 'selectors/tags';
import { handleError } from 'services/ErrorService/ErrorService';

const mapStateToProps = (state) => {
  let allMessages = state.conversation.allMessages;
  const editorState = getNewMessagesEditor(state);
  const macroCouponCodeTypeId = getNewMessagesCouponCodeType(state);
  const ticketLoaded = isSelectedConversationLoaded(state);
  const selectedTicketId = extractSelectedTicketIdFromState(state);
  const businessDetailsForTicket = extractSelectedTicketBusinessDetailsFromState(state);

  return {
    allMessages: getAllMessages(state),
    message: Object.assign({}, state.conversation[allMessages[0]]),
    showTools: state.ui.tools.general.showTools,
    latestMessageId: allMessages[allMessages.length - 1],
    editorState,
    getEditorStateFromId: (ticketId) => getNewMessagesEditor(state, ticketId),
    macroCouponCodeTypeId,
    btnActivity: state.ui.buttons.btnActivity,
    checkSmbSpelling: checkSmbSpelling(state),
    checkGreeting: checkPrePopulatedResponseConfig(state), // if we the config needs prepopulated response, check the greeting,
    hasExpertReplied: hasExpertReplied(state),
    ticketLoaded,
    ticket: extractSelectedTicketFromState(state),
    ticketId: extractSelectedTicketIdFromState(state),
    messagesViewed: hasMessageBeenRead(state),
    blacklistWords: getBusinessBlacklistWordsInfoOfSelectedTicket(state),
    blacklistRegexes: getBusinessBlacklistRegexesInfoOfSelectedTicket(state),
    smbTaggingActive: isSmbTaggingRequiredForSelectedTicket(state),
    selectedInboxTab: extractSelectedInboxTab(state),
    selectedUnSentMessage: getSelectedUnSentMessage(state),
    currentConversation: state.conversation,
    multiIntentClassification: getMultiIntentClassification(state),
    chatMacroRecommendationsEnabled:
      state.ui.messages.chatMacroRecommendationsEnabled &&
      extractSelectedTicketBusinessDetailsFieldValueFromState(state, 'showChatMacroRecommendations'),
    showChatMacroRecommendationsTargetUserType: extractSelectedTicketBusinessDetailsFieldValueFromState(
      state,
      'showChatMacroRecommendationsTargetUserType'
    ),
    user: state.user,
    chatMacroRecommendationsAvailable: chatMacroRecommendationsAvailable(state),
    shouldDisplayChatMacroRecommendations: shouldDisplayChatMacroRecommendations(state),
    lastSimplrMessageBody: getLastSuccessfulMessageFromSimplr(state),
    clipboardText: getClipboardTextForSpecificTicketId(state, selectedTicketId),
    selectedTicketId,
    disableEmojis: !!extractSelectedTicketBusinessDetailsFieldValueFromState(state, 'disableEmojis'),
    debounceAmountForGetPredictionText: extractDebounceAmountForGetPredictionTextFromState(state),
    isCommerceWizardActive: isCommerceWizardActive(state),
    simplrTags: extractSimplrTags(state),
    disableSimplrTaggingRequired: businessDetailsForTicket.disableSimplrTaggingRequired || false,
    isTicketTranslated: selectIsTicketTranslated(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleEscalationPopup(ticket, escalationReason = null, escalateToBusinessAsExpert = false) {
      dispatch(handleEscalationPopup(ticket, escalationReason, escalateToBusinessAsExpert));
    },
    onSendMessage: async (
      messageDetails,
      messageValue,
      buttonId,
      conversationId,
      lastSimplrMessageBody,
      macroCouponCodeTypeId,
      userConfirmedWords
    ) => {
      try {
        await dispatch(
          sendMessage(
            messageValue,
            buttonId,
            conversationId,
            lastSimplrMessageBody,
            macroCouponCodeTypeId,
            userConfirmedWords
          )
        );
      } catch (error) {
        handleError({ error });
      }
    },
    scrollRequirementMet() {
      dispatch(scrollRequirementMet());
    },
    loadBusinessAlertsForAccount() {
      dispatch(loadBusinessAlertsForAccount());
    },
    saveNewMessageEditorState(conversationObjId, editorState, discountPeriodId) {
      dispatch(saveNewMessageEditorState(conversationObjId, editorState, discountPeriodId));
    },
    clearPendingCaretInsert(conversationObjId) {
      dispatch(clearPendingCaretInsert(conversationObjId));
    },
    setBtnActivity(buttonId, isActive) {
      dispatch(setBtnActivity(buttonId, isActive));
    },
    onPaste: (text, html) => {
      let pastedText = text || html;
      dispatch(onPasteText(pastedText));
    },
    async loadPartnerTags() {
      return dispatch(loadPartnerTagsForSelectedTicketOfTab());
    },
    setChatMacroRecommendationsEnabled: (enabled) => {
      dispatch(setChatMacroRecommendationsEnabled(enabled));
    },
    addNoteToSpecificTicket: (messageBody, ticketId, noteType) => {
      dispatch(addNoteToSpecificTicket(messageBody, ticketId, noteType));
    },
    handleUseChatMacroRecommendation(simplrTags, copyFunction) {
      return dispatch(handleUseChatMacroRecommendation(simplrTags, copyFunction));
    },

    /**
     * Resets state.conversation.{blockedWordsFound, overridableWordsFound}.
     * Useful for hiding constraints-related dialogs after the user has acknowledged seeing them and wants them gone.
     */
    resetMessageConstraintsFound() {
      dispatch(setConversationBlockedWordsFound([]));
      dispatch(setConversationOverridableWordsFound([]));
    },
  };
};

const NewMessageContainer = connect(mapStateToProps, mapDispatchToProps)(NewMessage);

export default NewMessageContainer;
